import store from "../storeWire";
import {
    fetch_static_columns,
    set_saved_columns_preference_by_bom_id,
    fetch_saved_columns_data_by_bom_id,
    fetch_saved_preference_by_bom_id,
    SET_bomDataList_based_on_ROW_selected
} from "../store/slice/model/BOMReMatch";
import {useSelector} from "react-redux";

export function useBOMRematchStore() {
    const row_selected_number = useSelector((state) => state.entities.model_BOMReMatch.row_selected_number)
    const static_columns = useSelector((state) => state.entities.model_BOMReMatch.static_columns)
    const bom_data_list = useSelector((state) => state.entities.model_BOMReMatch.bomDataList)
    const bom_data_list_main_copy = useSelector((state) => state.entities.model_BOMReMatch.bomDataListMainCopy)
    const column_mapping_list = useSelector((state) => state.entities.model_BOMReMatch.columnMappingList)
    let data = {
        row_selected_number,
        static_columns,
        bom_data_list,
        bom_data_list_main_copy,
        column_mapping_list,
    };
    let fetch = {
        fetch_static_columns: async () => {
            return await store.dispatch(fetch_static_columns())
        },
        fetch_saved_columns_data_by_bom_id: async (params) => {
            return await store.dispatch(fetch_saved_columns_data_by_bom_id(params.bomId))
        },
        fetch_saved_preference_by_bom_id: async (params) => {
            return await store.dispatch(fetch_saved_preference_by_bom_id(params.bomId))
        },
    };
    let set = {
        set_saved_columns_preference_by_bom_id: async (params) => {
            return await store.dispatch(set_saved_columns_preference_by_bom_id(params))
        },
        SET_bomDataList_based_on_ROW_selected: async (row_selected_number) => {
            return await store.dispatch(SET_bomDataList_based_on_ROW_selected({row_selected_number}))
        },
    };
    return [data, fetch, set]
}